import React, { createContext, useContext, useState, useEffect } from 'react';

const AudienceContext = createContext(null);

export function AudienceProvider({ children }) {
  const [audience, setAudienceState] = useState('family');
  useEffect(() => {
    const saved = localStorage.getItem('poc.audience');
    if (saved === 'family' || saved === 'investor') setAudienceState(saved);
  }, []);
  const setAudience = (a) => {
    setAudienceState(a);
    localStorage.setItem('poc.audience', a);
  };
  return (
    <AudienceContext.Provider value={{ audience, setAudience }}>
      {children}
    </AudienceContext.Provider>
  );
}

export function useAudience() {
  return useContext(AudienceContext);
}
